<template>
  <admin-wrapper
    title-translation-path="admin.dataLayers"
    subtitle-path="admin.dataLayersSubtitle"
    :is-fetched="isFetched"
    :hasButtons="false"
  >
    <template #form>
      <v-row no-gutters>
        <v-col>
          <draggable-lists-layers scope="core" :is-fetched="isFetched" schema_scope="core" />
        </v-col>
      </v-row>
    </template>
  </admin-wrapper>
</template>

<script>
import AdminWrapper from '@/components/AdminWrapper';
import DraggableListsLayers from '@/components/DraggableListsLayers';

import { call } from 'vuex-pathify';

export default {
  name: 'AdminDataLayers',
  components: {
    AdminWrapper,
    DraggableListsLayers,
  },
  data: () => ({
    isFetched: false,
  }),
  methods: {
    getDatasourcesSettings: call('datasourceSettings/getDatasourcesSettings'),
    getLayers: call('layers/getLayers'),
    getDataSources: call('layers/getLayersMetadata'),
    getLayersSchemaByScope: call('layers/getLayersSchemaByScope'),
    async onInit() {
      await Promise.all([
        this.getDatasourcesSettings(),
        this.getDataSources({ with_attributes_schema: true, scope: 'core' }),
        this.getLayers({ scope: 'core' }),
        this.getLayersSchemaByScope({ layer_scope: 'core', schema_scope: 'core' }),
      ]);
      this.isFetched = true;
    },
  },
  created() {
    this.onInit();
  },
};
</script>
